import React from 'react';
import moment from 'moment';
import numberFormatter from '../../utils/numberFormatter.js'
import QueryStringService from '../../services/queryStringService.js'

export default class CampaignDetailsPlayOld extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.state = {
            showScreens: true
        };
    }

    render() {
        let ots = numberFormatter.numberWithSpaces(this.props.selectedDetailsData.contacts.delivered);
        let vac = this.props.selectedDetailsData.totalVAC
        let alternateVac = this.props.selectedDetailsData.totalAlternateVAC
        let plays = numberFormatter.numberWithSpaces(this.props.campaignInfo.plays)
        let screens = numberFormatter.numberWithSpaces(this.props.campaignInfo.screens)
        let spotlengthText = '';
        let country = this.queryStringService.getCurrentCountry();
        let vac5secAsterix = '*'
        let vac10secAsterix = ''
        let periodEnd = new Date(this.props.selectedDetailsData.endDate);
        let cutoff5secDate = new Date("2023-08-21T00:00:00");

        let useOneVacValue = !this.props.parameters.useOTS && (!this.props.useAlternateContacts || this.props.spotlength === 5 || this.props.spotlength === '')
        if (country === 'no' && periodEnd > cutoff5secDate && !this.props.orderlineInExceptionList && !useOneVacValue){
            vac5secAsterix = ''
            vac10secAsterix = '*'
            const temp = vac
            vac = alternateVac
            alternateVac = temp
        }

        if (this.props.spotlength === 'mixed'){
            spotlengthText = 'Mixed (' + this.props.selectedDetailsData.spotlengths.join(', ') + ')';
        }
        else if (this.props.spotlength !== ''){
            spotlengthText = this.props.selectedDetailsData.spotlengths[0];
        }

        return (
            <div className="campaign-details">
                <div className="row">
                    <div className="col-md-6">
                        <table>
                            <tbody>
                                <tr>
                                    <th>Customer</th>
                                    <td>{this.props.orderData.customer}</td>
                                </tr>
                                <tr>
                                    <th>{'Period'}<br/>{(this.props.periodManuallySelected ? ' (manually selected)' :'') }</th>
                                    <td>{moment(this.props.selectedDetailsData.startDate).format('YYYY-MM-DD')}<br />{moment(this.props.selectedDetailsData.endDate).format('YYYY-MM-DD')}</td>
                                </tr>
                                {this.props.campaignName &&
                                <tr>
                                    <th>Campaign name</th>
                                    <td>{this.props.campaignName}</td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6">
                        <table>
                            <tbody>
                                <tr>
                                    <th>Delivered Spot length</th>
                                    <td>{spotlengthText} sec</td>
                                </tr>
                                {this.props.parameters.useOTS &&
                                <tr>
                                    <th>Contacts</th>
                                    <td>{ots}</td>
                                </tr> }
                                {useOneVacValue &&
                                <tr>
                                    <th>VAC Contacts</th>
                                    <td>{numberFormatter.numberWithSpaces(vac)}</td>
                                </tr>
                                }
                                {this.props.useAlternateContacts && this.props.spotlength === 10 &&
                                <tr>
                                    <th>VAC Contacts (10 sec){vac10secAsterix}</th>
                                    <td>{numberFormatter.numberWithSpaces(alternateVac)}</td>
                                </tr>
                                }
                                <tr>
                                    <th>Plays</th>
                                    <td>{plays}</td>
                                </tr>
                                {this.state.showScreens &&
                                <tr>
                                    <th>Screens</th>
                                    <td>{screens}</td>
                                </tr>
                                }
                                {this.props.useAlternateContacts && this.props.spotlength !== 5 && this.props.spotlength !== '' &&
                                <tr>
                                    <th>VAC Contacts (5 sec){vac5secAsterix}</th>
                                    <td>{numberFormatter.numberWithSpaces(vac)}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        );
    }
}